import React, { Component } from 'react'
import './styles.sass'

export default class ActivityMobile extends Component {

    constructor(props) {
        super(props)

        this.state = {
            open: false
        }
    }

    handleClick = (open) => {
        this.setState({
            open: open
        })
    }

    render() {
        const { activity, labels } = this.props
        const { open } = this.state
        return (
            <div className={`row-activity-mobile ${open ? "open" : ""}`} >
                <div className="openRow" onClick={() => this.handleClick(!open)}></div>
                <div className="row">
                    <div className="activity-img">
                        <img src={activity.image} alt="activity" />
                    </div>
                    <div className="col">
                        <div className="activity-hour">
                            <div className="label-hour">{labels.courseBox_timing}</div>
                            <div className="time"><span className="timeFrom">{activity.timeFrom}</span><span className="timeOf">{activity.timeOf}</span></div>
                        </div>
                        <div className={`activity-category ${activity.groupType}`}>{activity.groupLabel}</div>
                        <div className="activity-courses">{activity.activity}</div>
                    </div>
                </div>
                { activity.trainerName && activity.trainerUrl ?
                    <div className="activity-trainer">
                        <div className="label-trainer">{labels.filtersBox_dropdown_trainer_label} <div className="no-btn"><a href={activity.trainerUrl}>{activity.trainerName}</a></div></div>
                        
                    </div>
                    : activity.trainerName &&
                    <div className="activity-trainer">
                        <div className="label-trainer">{labels.filtersBox_dropdown_trainer_label} <div className="no-btn"><span>{activity.trainerName}</span></div></div>
                        
                    </div>
                }
                <div className="place-details">
                    <span className="place-big">{activity.detailPlace}</span>
                    <a className="read-all" target="_blank" href={activity.detailPlaceUrl}>{labels.courseBox_see}</a>
                </div>   
                <div className={`details ${open ? "open" : ""}`}>
                    <div className="wrapper-description">
                        <p>{activity.description}</p>
                        <a className="read-all" target="_blank" href={activity.descriptionUrl}>{labels.courseBox_readAll}</a>
                    </div>
                    <div className="activity-cta">       
                        { activity.detailBooking &&
                            <a className="btn btn-orange" target="_blank" href={activity.detailBooking}>{labels.courseBox_booking}</a>
                        }
                        { activity.detailCourses &&
                            <a className="no-btn b" target="_blank" href={activity.detailCourses}>{labels.courseBox_discover}</a>
                        }
                        { activity.detailPrices &&
                            <a className="btn btn-white" target="_blank" href={activity.detailPrices}>{labels.courseBox_price}</a>
                        }
                    </div>
                </div>            
            </div>
        )
    }
}
